export const GetStartedEllipse = ({ colorCode, width = 400, height = 490 }) => {
    const planColors = {
        Free: "#3EAD75",
        Basic: "#2018A2",
        Pro: "#FC6432",
        started_blue: "#7177EA",
        started_middle: "#2F59AB",
        started_end: "#0B662D",
        megamenu: "#869BDD",
    };

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 309 477"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_f_7028_6771)">
                <rect
                    x="52"
                    y="-82"
                    width="204"
                    height="559"
                    rx="102"
                    fill={planColors[colorCode]}
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_7028_6771"
                    x="-248"
                    y="-382"
                    width="804"
                    height="1159"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="150"
                        result="effect1_foregroundBlur_7028_6771"
                    />
                </filter>
            </defs>
        </svg>
    );
};